<template>
  <div class="page-container">
    <page-header></page-header>
    <div class="dashboard-container">
      <div class="page-content">
        <div class="page-tabbar">
          <div class="left">
            <div :class="curTab === 'params' ? 'active': ''" @click="changeTab('params')">汽车运行参数</div>
            <div :class="curTab === 'rules' ? 'active': ''" @click="changeTab('rules')"
                 v-if="user && user.is_supper_admin">汽车计算模型
            </div>
          </div>
          <div class="right">
            <template v-if="curTab === 'params'">
              <el-button @click="getParams(true)" size="medium" type="default">刷新参数</el-button>
              <el-button @click="downloadTemplate('params')" size="medium" type="default">下载模板</el-button>
              <el-upload action="-" accept="xls,xlsx" :http-request="handleImportParams" :show-file-list="false"
                         style="margin-left: 10px;display: inline-block;">
                <el-button size="medium" type="primary">导入参数</el-button>
              </el-upload>
            </template>
            <template v-if="curTab === 'rules'">
              <el-button @click="ruleAdd" size="medium" type="default">新增规则</el-button>
              <el-button @click="downloadTemplate('rules')" size="medium" type="default">下载模板</el-button>
              <el-upload action="-" accept="xls,xlsx" :http-request="handleImportRule" :show-file-list="false"
                         style="margin-left: 10px;display: inline-block;">
                <el-button size="medium" type="primary">导入规则</el-button>
              </el-upload>
            </template>
          </div>
        </div>
        <div class="params-container" v-if="curTab === 'params'">
          <div class="param-box">
            <div class="title">整车参数</div>
            <div class="info">
              <div>
                <span>总里程:</span>
                <span>{{ params.full_mileage }}km</span>
              </div>
              <div>
                <span>总耗电量:</span>
                <span>{{ params.full_power_consumption }}kwh</span>
              </div>
              <div>
                <span>总启动时长:</span>
                <span>{{ params.full_run_seconds | toLocalTime }}</span>
              </div>
              <div>
                <span>本次里程耗电量:</span>
                <span>{{ params.power_consumption }}kwh</span>
              </div>
              <div>
                <span>本次里程:</span>
                <span>{{ params.mileage || 0 }}km</span>
              </div>
              <div>
                <span>本次启动时长:</span>
                <span>{{ params.run_seconds | toLocalTime }}</span>
              </div>
              <div>
                <span>甲醇容量:</span>
                <span>{{ params.methanol_full_amount }}L</span>
              </div>
              <div>
                <span>甲醇余量:</span>
                <span>{{ params.methanol_left_amount }}L</span>
              </div>
              <div>
                <span>水容量:</span>
                <span>{{ params.water_full_amount }}L</span>
              </div>
              <div>
                <span>水余量:</span>
                <span>{{ params.water_left_amount }}L</span>
              </div>
              <div>
                <span>电池容量:</span>
                <span>{{ params.power_full_amount }}kwh</span>
              </div>
              <div>
                <span>电池余量:</span>
                <span>{{ params.power_left_amount }}kwh</span>
              </div>
            </div>
          </div>
          <div class="param-box" style="margin: 0  60px">
            <div class="title">甲醇重整器参数</div>
            <div class="info">
              <div>
                <span>运行总时长:</span>
                <span>{{ params.machine_full_run_seconds | toLocalTime }}</span>
              </div>
              <div>
                <span>本次启动时长:</span>
                <span>{{ params.machine_run_seconds | toLocalTime }}</span>
              </div>
              <div>
                <span>当前环境PH值:</span>
                <span>{{ params.machine_ph }}</span>
              </div>
              <div>
                <span>当前温度:</span>
                <span>{{ params.machine_temperature }}°C</span>
              </div>
              <div>
                <span>当前气压:</span>
                <span>{{ params.machine_pressure }}Mp</span>
              </div>
              <div>
                <span>加醇总量:</span>
                <span>{{ params.machine_methanol_amount }}L</span>
              </div>
              <div>
                <span>耗醇总量:</span>
                <span>{{ params.machine_methanol_full_consume_amount }}L</span>
              </div>
              <div>
                <span>本次启动耗醇量:</span>
                <span>{{ params.machine_methanol_consume_amount }}L</span>
              </div>
              <div>
                <span>当前醇耗:</span>
                <span>{{ params.machine_methanol_consume_ratio }}</span>
              </div>
              <div>
                <span>加水总量:</span>
                <span>{{ params.machine_water_amount }}L</span>
              </div>
              <div>
                <span>耗水总量:</span>
                <span>{{ params.machine_water_full_consume_amount }}L</span>
              </div>
              <div>
                <span>本次启动耗水量:</span>
                <span>{{ params.machine_water_consume_amount }}L</span>
              </div>
              <div>
                <span>当前水耗:</span>
                <span>{{ params.machine_water_consume_ratio }}</span>
              </div>
              <div>
                <span>当前水醇比:</span>
                <span>{{ params.machine_water_methanol_ratio }}</span>
              </div>
              <div>
                <span>本次启动发电量:</span>
                <span>{{ params.machine_create_power }}kwh</span>
              </div>
              <div>
                <span>蒸气成分氯含量:</span>
                <span>{{ params.machine_cl_ratio }}</span>
              </div>
              <div>
                <span>蒸气成份硫含量:</span>
                <span>{{ params.machine_s_ratio }}</span>
              </div>
            </div>
          </div>
          <div class="param-box">
            <div class="title">产物气体含量</div>
            <div class="info">
              <div>
                <span>CH3OH:</span>
                <span>{{ params.machine_ch3oh_ratio }}</span>
              </div>
              <div>
                <span>CO:</span>
                <span>{{ params.machine_co_ratio }}</span>
              </div>
              <div>
                <span>H2O:</span>
                <span>{{ params.machine_h2o_ratio }}</span>
              </div>
              <div>
                <span>CO2:</span>
                <span>{{ params.machine_co2_ratio }}</span>
              </div>
              <div>
                <span>H2:</span>
                <span>{{ params.machine_h2_ratio }}</span>
              </div>
              <div>
                <span>积碳检测:</span>
                <span>{{ params.machine_carbon_deposition ? '有' : '无' }}</span>
              </div>
            </div>
          </div>
          <!--

                  <el-button size="mini" style="margin-right: 10px" type="primary" @click="getParams">刷新参数</el-button>
                  <el-upload action="-" accept="xls,xlsx" style="display: inline-block;" :http-request="handleImportParams"
                             :show-file-list="false" class="item">
                    <el-button class="option" size="mini" type="danger">导入参数</el-button>
                  </el-upload>-->
        </div>
        <div class="rule-container" v-if="curTab === 'rules'">
          <el-table border :data="rules" :header-cell-style="{background:'#17A6BF',color:'#fff'}">
            <el-table-column prop="formula" label="公式"></el-table-column>
            <el-table-column prop="level" label="等级" width="120" align="center">
              <template slot-scope="scope">
                <span v-if="scope.row.level === 3" style="color: #f5cc05;">提示</span>
                <span v-if="scope.row.level === 2" style="color: #1FFFFF;">普通</span>
                <span v-if="scope.row.level === 1" style="color: #FF386B;">严重</span>
              </template>
            </el-table-column>
            <el-table-column prop="message" label="告警内容" width="440"></el-table-column>
          </el-table>
          <!--   <div style="margin-top: 10px;"></div>
             <el-button size="mini" style="margin-right: 10px" type="primary" @click="ruleAdd">新增规则</el-button>
             <el-upload action="-" accept="xls,xlsx" style="display: inline-block;" :http-request="handleImportRule"
                        :show-file-list="false" class="item">
               <el-button class="option" size="mini" type="danger">导入规则</el-button>
             </el-upload>-->
        </div>
        <el-dialog title="新增规则" :visible.sync="show_form_dialog" append-to-body
                   :close-on-click-modal="false" custom-class="min-w-800">
          <el-form :model="formData" :rules="formRules" label-width="120px" ref="formData"
                   v-loading="form_loading">
            <el-form-item label="公式" prop="formula">
              <el-input placeholder="公式" v-model="formData.formula"></el-input>
            </el-form-item>
            <el-form-item label="等级" prop="level">
              <el-select v-model="formData.level" placeholder="等级">
                <el-option label="提示" :value="3"></el-option>
                <el-option label="普通" :value="2"></el-option>
                <el-option label="严重" :value="1"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="告警内容" prop="message">
              <el-input placeholder="告警内容" v-model="formData.message"></el-input>
            </el-form-item>
            <div class="dialog-footer">
              <el-button @click="show_form_dialog = false">取 消</el-button>
              <el-button @click="submit('formData')"
                         style="background: #17A6BF;color: #fff;border:1px solid #17A6BF;">确 定
              </el-button>
            </div>
          </el-form>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import {alarmRules, alarmRuleCreate, alarmRuleImport, paramsLast, paramsImport} from "@/api/car"
import PageHeader from "@/components/PageHeader.vue"

export default {
  name: "Setting",
  components: {PageHeader},
  data() {
    return {
      type: 'car',
      curTab: 'params', // rules
      //
      params: {
        running_speed: 0, // 速度 km/h
        last_running_speed: 0, // 速度 km/h 上一次
        last_stop_timestamp: 0, // 上一次停车（运行中但速度为0）时间戳
        full_mileage: 0, // 总里程 km
        full_power_consumption: 0, //总耗电量 kwh
        full_run_seconds: 0, // 总启动时长 s
        power_consumption: 0, //本次里程耗电量 kwh
        run_seconds: 0, // 本次启动时长 s
        methanol_full_amount: 100, // 甲醇容量 L
        methanol_left_amount: 100, // 甲醇余量 L
        water_full_amount: 100, // 水容量 L
        water_left_amount: 100, // 水余量 L
        power_full_amount: 100, // 电池总容量 kwh
        power_left_amount: 60, // 剩余电量 kwh
        // 甲醇重整器参数
        machine_full_run_seconds: 0, // 运行总时长 s
        machine_run_seconds: 0, // 本次启动时长 s
        machine_ph: 0, // 当前环境PH值
        machine_temperature: 0, // 当前温度
        machine_pressure: 0, // 当前气压
        // 醇
        machine_methanol_amount: 100, // 加醇总量 L
        machine_methanol_full_consume_amount: 0, // 耗醇总量 L
        machine_methanol_consume_amount: 0, // 本次启动耗醇量 L
        machine_methanol_consume_ratio: 0, // 当前醇耗
        // 水
        machine_water_amount: 130, // 加水总量 L
        machine_water_full_consume_amount: 0, // 耗水总量 L
        machine_water_consume_amount: 0, // 本次启动耗水量 L
        machine_water_consume_ratio: 0, // 当前水耗

        machine_water_methanol_ratio: 1.3, // 当前水醇比

        machine_create_power: 0, // 本次启动发电量 kwh
        machine_cl_ratio: 0, // 蒸气成分氯含量
        machine_s_ratio: 0, // 蒸气成份硫含量
        machine_ch3oh_ratio: 0, // 产物气体含量 CH3OH
        machine_co_ratio: 0, // 产物气体含量 CO
        machine_h2o_ratio: 0, // 产物气体含量 H20
        machine_co2_ratio: 0, // 产物气体含量 CO2
        machine_h2_ratio: 0, // 产物气体含量 H2
        machine_carbon_deposition: 0, // 积碳检测
      },
      rules: [],
      //
      formData: {
        type: 'car',
        formula: '',
        level: 3,
        message: '',
      },
      formRules: {
        formula: [
          {required: true, message: '请输入公式', trigger: 'blur'},
        ],
        level: [
          {required: true, message: '请选择告警等级', trigger: 'blur'},
        ],
        message: [
          {required: true, message: '请输入告警内容', trigger: 'blur'},
        ],
      },
      form_loading: false,
      show_form_dialog: false,
    }
  },
  computed: {
    user() {
      return this.$store.state.auth.user
    },
  },
  filters: {
    toLocalTime(seconds) {
      let left_seconds = seconds
      let hour = 0, minute = 0
      if (left_seconds >= 3600) {
        hour = Math.floor(left_seconds / 3600)
        left_seconds = left_seconds % 3600
      }
      if (left_seconds >= 60) {
        minute = Math.floor(left_seconds / 60)
        left_seconds = left_seconds % 60
      }
      return hour + '小时' + minute + '分钟' + left_seconds + '秒'
    },
  },
  created() {
    if (!this.user.has_car_permission) {
      this.$router.replace('/index')
    }
  },
  mounted() {
    this.getParams()
    this.getRules()
  },
  methods: {
    changeTab(key) {
      if (key === this.curTab) return
      this.curTab = key
      if (key == 'params') {
        this.getParams()
      }
      if (key == 'rules') {
        this.getRules()
      }
    },
    getParams(is_refresh = false) {
      let that = this
      console.log('用户点击刷新参数')
      paramsLast({type: that.type}).then(res => {
        that.params = res
        is_refresh && that.$message.success('刷新参数成功')
      })
    },
    getRules() {
      let that = this
      alarmRules({type: that.type}).then(res => {
        that.rules = res
      })
    },
    ruleAdd() {
      let that = this
      that.formData = {
        type: that.type,
        formula: '',
        level: 3,
        message: '',
      }
      that.show_form_dialog = true
    },
    submit(formName) {
      let that = this
      that.$refs[formName].validate((valid) => {
        if (valid) {
          that.form_loading = true
          alarmRuleCreate(that.formData).then(() => {
            that.form_loading = false
            that.$message.success('操作成功')
            that.show_form_dialog = false
            setTimeout(() => {
              that.getRules()
            }, 500)
          }).catch(() => {
            that.form_loading = false
          })
        }
      })
    },
    handleImportParams(source) {
      let that = this
      let loadingInstance = that.$loading()
      paramsImport(source.file, that.type).then(() => {
        loadingInstance.close()
        that.$message.success('操作成功')
        that.getParams()
      }).catch((err) => {
        console.log(err)
        loadingInstance.close()
        that.$message.error('导入失败，请重试')
      })
    },
    handleImportRule(source) {
      let that = this
      let loadingInstance = that.$loading()
      alarmRuleImport(source.file, that.type).then(() => {
        loadingInstance.close()
        that.$message.success('操作成功')
        that.getRules()
      }).catch((err) => {
        console.log(err)
        loadingInstance.close()
        that.$message.error('导入失败，请重试')
      })
    },
    // 下载模板
    downloadTemplate(key) {
      if (key === 'params') {
        location.href = "/templates/汽车初始参数导入模板.xlsx";
      } else if (key === 'rules') {
        location.href = "/templates/汽车告警规则导入模板.xlsx";
      } else {
        this.$message.error('无法下载')
      }
    }
  }
}
</script>

<style scoped lang="scss">
$pageColor: #17A6BF;
$pageColorBlack: #2F3133;
.page-tabbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #CED4DB;

  .left {
    & > div {
      display: inline-block;
      height: 64px;
      line-height: 60px;
      text-align: center;
      margin-left: 40px;
      font-size: 20px;
      cursor: pointer;

      &:first-child {
        margin-left: 0;
      }

      &.active {
        border-bottom: 4px solid $pageColor;
        color: $pageColor
      }
    }
  }

  .right {

  }
}

.params-container {
  padding-top: 40px;
  width: 1200px;
  height: auto;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;

  .param-box {
    width: 360px;
    padding: 24px 32px;
    flex: 1;
    border-radius: 12px;
    border: 1px solid #EDEDED;

    .title {
      background: $pageColor;
      text-align: center;
      border-radius: 4px;
      height: 32px;
      line-height: 32px;
      color: #ffffff;
      margin-bottom: 16px;
    }

    .info {
      & > div {
        display: flex;
        margin-top: 4px;

        &:first-child {
          margin-top: 0;
        }

        span {
          flex: 1;
          font-size: 14px;
          line-height: 22px;

          &:first-child {
            text-align: right;
            padding-right: 9px;
            color: #8D9094;
          }

          &:last-child {
            text-align: left;
            padding-left: 9px;
            color: $pageColorBlack;
          }

        }
      }
    }

  }


  p {
    font-size: 14px;
    line-height: 1.4;
  }

  hr {
    margin-block-start: 0.5em;
    margin-block-end: 0.5em;
  }
}

.rule-container {
  padding-top: 40px;
  width: 1200px;
  height: auto;
  margin: 0 auto;
}
</style>
